export const TIER_STYLES = {
  L1: "bg-zinc-100 text-zinc-700",
  "L1.5": "bg-amber-50 text-amber-700",
  L2: "bg-blue-50 text-blue-700",
  L3: "bg-emerald-50 text-emerald-700",
};

const ACTIVE_STYLES = {
  L1: "bg-zinc-800 text-white border-zinc-800",
  "L1.5": "bg-amber-600 text-white border-amber-600",
  L2: "bg-blue-600 text-white border-blue-600",
  L3: "bg-emerald-600 text-white border-emerald-600",
};

export function TierBadge({ tier, className = "" }) {
  return (
    <span className={`rounded-sm px-1.5 py-0.5 text-[11px] font-medium ${TIER_STYLES[tier] || "bg-zinc-100 text-zinc-600"} ${className}`} data-testid={`tier-badge-${tier}`}>
      {tier}
    </span>
  );
}

export default function TierFilter({ tiers, selected, onChange, testidPrefix = "tier-filter" }) {
  const toggle = (t) => {
    const next = new Set(selected);
    if (next.has(t)) next.delete(t); else next.add(t);
    onChange(next);
  };

  const allSelected = tiers.every((t) => selected.has(t));
  const toggleAll = () => {
    if (allSelected) onChange(new Set());
    else onChange(new Set(tiers));
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`${testidPrefix}-group`}>
      <button data-testid={`${testidPrefix}-all`} onClick={toggleAll}
        className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${allSelected ? "bg-zinc-900 text-white border-zinc-900" : "bg-white text-zinc-600 border-zinc-300 hover:bg-zinc-50"}`}>
        All
      </button>
      {tiers.map((t) => {
        const on = selected.has(t);
        return (
          <button key={t} data-testid={`${testidPrefix}-${t}`} onClick={() => toggle(t)}
            className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${on ? ACTIVE_STYLES[t] : `bg-white text-zinc-600 border-zinc-300 hover:bg-zinc-50`}`}>
            {t}
          </button>
        );
      })}
    </div>
  );
}
